const style1 = {
    backgroundColor: "#fff",
    display: "inline-block",
    fontFamily:"Roboto,sans-serif",
    color: "#a7a7a7",
    fontSize: "11px",
    width:" 100%",
    maxWidth:"372px"
}
const style2 = {
    padding:"0",
    margin: "0",
    textAlign: "left"
}
const style3 = {
    color:"#a7a7a7",
    textDecoration: "none",
    fontWeight: "normal",
    border: "none",
    display: "inline-block"
}
const style4 = {
    overflow: "hidden",
    position:"relative",
    height:"0",
    padding:"124.19355% 0 0 0",
    width:"100%"
}
const style5 = {
    display:"inline-block",
    position:"absolute",
    top:"0",
    left:"0",
    width:"100%",
    height:"100%",
    margin:"0"
}
function LincolnAbrahamEmbed(){
    return (
        <>
        <div className="getty embed image" style={style1}><div style={style2}><a href="http://www.gettyimages.com/detail/1286214418" target="_blank" rel="noreferrer" style={style3}>Embed from Getty Images</a></div><div style={style4}><iframe src="//embed.gettyimages.com/embed/1286214418?et=uqALvlqiRrFOgPP3rHn7cA&tld=com&sig=52NTbYgLBWAigKtCjxD9A4eW_lT7gXoUOV3WNFQdA-A=&caption=true&ver=1" title="Abraham Lincoln" scrolling="no" frameBorder="0" width="372" height="462" style={style5}></iframe></div></div>
        </>
    );
};
export default LincolnAbrahamEmbed;